import React, { useEffect } from "react";
import { Button, FormHelperText, Grid, OutlinedInput, TextField } from "@mui/material";
import AttachFileIcon from '@mui/icons-material/AttachFile';

export interface DefaultUploadFileProps {
    setFileUpload: (file: File) => void,
    file: File | undefined,
    extensions?: string[],
    maxFileSizeMb?: number,
    id: string,
    error?: boolean,
}

export default function DefaultUploadFile({ props }: { props: DefaultUploadFileProps }) {
    const [selectedFile, setSelectedFile] = React.useState<File | undefined>(props.file);
    const [errorFile, setErrorFile] = React.useState<string>();
    const handleChange = (selectedFile: FileList) => {
        setErrorFile(undefined);
        if (selectedFile != null && selectedFile.length > 0) {
            var file = selectedFile[0];

            if (validateFile(file)) {
                setSelectedFile(file);
                if (props.setFileUpload !== undefined && props.setFileUpload !== null) {
                    console.log("setFileUpload");
                    props.setFileUpload(file);
                }
            }
        }
    };
    const validateFile = (file: File) => {
        if (props.maxFileSizeMb !== undefined) {
            var maxFileSizeBytes = props.maxFileSizeMb * 1024 * 1024;
            if (file.size > maxFileSizeBytes) {
                setErrorFile(`O arquivo deve ter no máximo ${props.maxFileSizeMb} MB`);
                return false
            }
        }
        if (props.extensions !== undefined) {
            var ext = file.name.split('.').pop();
            if (ext !== undefined && !props.extensions.includes(ext)) {
                setErrorFile(`O arquivo deve ter uma das seguintes extensões: ${props.extensions.join(", ")}`);
                return false
            }
        }
        return true
    };
    useEffect(() => {
        setSelectedFile(props.file);
    }, [props.file]);
    return (
        <React.Fragment>

            <input
                style={{ display: 'none' }}
                id={props.id}
                multiple={false}
                type="file"
                onChange={(e: any) => handleChange(e.target.files)}
            />
            <label htmlFor={props.id}>

                <OutlinedInput
                    name={`input-file-${props.id}`}
                    fullWidth
                    readOnly={true}
                    error={props.error !== undefined ? props.error : errorFile !== undefined}
                    value={selectedFile?.name !== undefined ? selectedFile?.name : ""}

                    endAdornment={
                        <Button variant="contained" sx={{ pr: 3, pl: 3 }} component="span" endIcon={<AttachFileIcon />}
                        >
                            ...
                        </Button>
                    }
                />
                {errorFile && (
                    <FormHelperText error>
                        {errorFile}
                    </FormHelperText>
                )}
            </label>

        </React.Fragment>

    );
}